/*
  Homepage transparent overlay header — toggles `.is-solid` on scroll.
  At the top the header is transparent/light over the hero; once scrolled past a
  small threshold it becomes the solid, dark sticky header. Homepage only.
*/
(function () {
  function init() {
    var header = document.querySelector('[data-tata-overlay-header]');
    if (!header) return;
    var THRESHOLD = 30;
    function update() {
      header.classList.toggle('is-solid', (window.pageYOffset || document.documentElement.scrollTop) > THRESHOLD);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-bind if the header section is reloaded in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
